import styled, { keyframes } from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { FaLock } from 'react-icons/fa';
import { GoEyeClosed } from 'react-icons/go'

export const InfoContainer = styled.div`
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  background-size: 100% auto;
  padding: 0px 0px;
  // width: 50%

  @media screen and (max-width: 450px){
   width: 100%;
  }
`;


export const Form = styled.form`
  background: #f5f5f5;
  height: auto;
  display: grid;
  justify-content: center;
`;


export const FormH1 = styled.h1`
  margin-top: 10px;
  margin-bottom: 10px;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
   @media screen and (max-width: 450px) {
    margin-bottom: 2px;
  }
`

export const HeadingHelpersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 600px;

  
  @media screen and (max-width: 480px) {
    flex-direction: ${({ swap }) => (swap ? 'column' : 'row')};
    width: 300px;
  }
`


export const VStack = styled.div`
  display: flex;
  flex-direction: column;
`


export const ValueWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (min-width: 490px){
    justify-content: center;
  }
`;

export const FormInfoText = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  margin-right:10px;
  color: #010606;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
`;

export const FormInfoValue = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  color: ${({ errorText }) => (errorText ? '#006ee6' : 'red')};
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  text-align: center;
`;


export const SelectButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  justify-self: center;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  }

  
  @media screen and (max-width: 500px){
    margin-top: 0px;
  }
`;

export const TeamContainer = styled.div`
   display: grid;
   margin-top: 20px;
   grid-template-columns: repeat(3, 300px); /* 3 columns of 200px each */
   grid-gap: 20px; /* optional spacing between items */
   justify-content: center; /* optional: center the grid horizontally */
   overflow-y: scroll;

  
  @media screen and (max-width: 460px) {
  grid-template-columns: repeat(3, 110px); /* 3 columns of 200px each */
    grid-gap: 2px;
    padding: 2px 2px;
  }
`
export const TeamCardContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  // border-right-style: solid;
  // border-right-color: #006ee6;
  // border-right-width: 2px;
  grid-template-columns: 110px;
  grid-gap: 10px;
  
  @media screen and (min-width: 490px) {
    grid-template-columns: 300px;
    padding: 10px 10px;
  }
`;

export const TeamCard = styled.div`
  background-color: #000;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
  min-height:180px;
  margin-bottom: 5px;
  @media screen and (min-width: 490px) { 
    margin-bottom: 12px;
    width: 300px;
    min-height: 200px;
  }
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  align-items: center;
`;

export const TopLine = styled.div`
  color: #006ee6;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4px;
  margin-top: 2px;
  
  font-size: 10px;

  @media screen and (min-width: 490px){
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 16px;
  }
`;


export const FormH4 = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  font-size: 12px;
  color: ${({ errorText }) => (errorText ? 'red' : '#f5f5f5')};
  font-weight: bold;
  text-align: center;
`;

export const SlotCard = styled.div`
  background-color: transparent; /* transparent background */
  border: 2px solid #006ee6;      /* blue border */
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  color: white;
  margin-bottom: 12px;
  box-shadow: 0 0 10px rgba(0, 110, 230, 0.3); /* optional glow effect */
  display: flex;
  flex-direction: column;
   height: 200px;
  @media screen and (max-width: 490px) { 
    margin-bottom: 5px;
    height: 140px;
  }
`;

export const ImgWrap = styled.div`
  width: 30px;
  height: 30px;
  margin-bottom: 8px;
  justify-content: center;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const DetailsWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 100px;
  align-items: center;
  
  @media screen and (min-width: 490px) { 
    min-width: 200px;
`;

export const StatsWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
`;


export const LoadButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 5px;
  background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#006ee6')};
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  margin-right: 5px;
  font-weight: bold;
  animation: 2s linear ${spin} infinite;
`

export const LockedIcon = styled(FaLock)`
  margin-right: 5px;
  font-weight: bold;
`